module.exports = __webpack_public_path__ + "img/slide_2_3.94dc2e9d.jpg";